import ContextStorage from './context-storage'
import VersioningStorage from './versioning-storage'

// eslint-disable-next-line no-unused-vars
import Context from '@/auth/context'

import Logger from '@/logger'

/**
 * Local storage instances.
 */
export default class LocalStorageGateway {

    /**
     *Creates an instance of LocalStorageGateway.
     * @param {Context} authContext
     * @memberof LocalStorageGateway
     */
    constructor(authContext, useSessionStorage = false) {
        this.authContext = authContext
        this.useSessionStorage = useSessionStorage
    }

    /**
     * Context storage
     *
     * @readonly
     * @memberof LocalStorageGateway
     */
    get context() {
        return new ContextStorage(this.useSessionStorage)
    }

    /**
     * Versioning (migrations) storage
     *
     * @readonly
     * @memberof LocalStorageGateway
     */
    get versioning() {
        return new VersioningStorage()
    }

    /**
     * Clears all of the associated context.
     *
     * @returns {Promise<boolean>} A flag, to indicate if context was cleared
     * @memberof LocalStorageGateway
     */
    async clearContextAsync() {
        return await this.context.clearAsync()
    }

    /**
     * Clones all of the associated user / context data to a different auth context key.
     *
     * @param {string} newContextId
     * @returns {Promise<Object>} The responses
     * @memberof LocalStorageGateway
     */
    async cloneAsync(newContextId) {
        Logger.log('Kicking off parallel tasks to await for cloning local data...', 'Storage')
        const responses = await Promise.all([
            this.versioning.cloneAsync(this.authContext, newContextId),
        ])

        return {
            versioningResponse: responses[0],
        }
    }
}
